import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal from 'components/Modal';
import actions from 'state/actions';
import selectors from 'state/selectors';
import services from 'services';
import utils from 'utils';

export default () => {
  const t = utils.intl.useTranslator();
  const modalProps: { filters: any } = useSelector(selectors.modal.getModalProps);
  const { filters } = modalProps || {};

  const dispatch = useDispatch();

  const handleConfirm = async () => {
    try {
      const { data } = await services.execKpiReport(filters);

      const filename = `report_${new Date().getTime()}`;

      utils.file.downloadFileFromBase64Source(filename, data.file, 'application/csv', 'csv');
      dispatch(actions.modal.closeModal());
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <Modal.Header title={t('kpi-report-export-title')} subtitle={t('kpi-report-export-description')} />
      <Modal.Footer confirmAction={handleConfirm} confirmText={t('kpi-export-confirm')} />
    </>
  );
};
